import { WeatherStationRealTimeByCityModel } from '../models/weather-station-real-time-by-city';

export class WeatherStationRealTimeByCityAdapter {
  static fromApi(response: any): WeatherStationRealTimeByCityModel | null {
    const data = response.data || response;

    // Verificar se data está vazio ou não tem os campos essenciais
    if (!data || Object.keys(data).length === 0 || data.id === undefined) {
      return null;
    }

    return {
      id: data.id,
      hashId: data.hashId,
      identification: data.identification,
      generationDate: data.generationDate,
      generationTime: data.generationTime,
      temp: data.temp,
      tempMin: data.tempMin,
      tempMax: data.tempMax,
      rain: data.rain,
      dataSource: data.dataSource,
      stationId: data.stationId,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }
}
